module.exports = __webpack_public_path__ + "static/media/4.87e8b662.JPG";